import React from 'react';
import "../../styles/CreatorRoadmap.css";

export default function CreatorRoadmap() {
  const stepsData = [
    { 
      num: "01", 
      title: "Beginner", 
      sub: "Master Basics",
      themeClass: "step-cyan",
      iconSvg: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1-2.5-2.5Z" />
          <path d="M6 6h10" />
          <path d="M6 10h7" />
        </svg>
      )
    },
    { 
      num: "02", 
      title: "Creator", 
      sub: "Produce & Post",
      themeClass: "step-blue",
      iconSvg: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="23 7 16 12 23 17 23 7" />
          <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
        </svg>
      )
    },
    { 
      num: "03", 
      title: "Monetize", 
      sub: "First ₹ Income",
      themeClass: "step-gold",
      iconSvg: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <line x1="12" y1="1" x2="12" y2="23" />
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
        </svg>
      )
    },
    { 
      num: "04", 
      title: "Brand Deals", 
      sub: "High-Ticket Clients",
      themeClass: "step-purple",
      iconSvg: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      )
    },
    { 
      num: "05", 
      title: "Authority", 
      sub: "Scale Personal Brand",
      themeClass: "step-emerald",
      iconSvg: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="8" r="6" />
          <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11" />
        </svg>
      )
    },
    { 
      num: "06", 
      title: "Full-Time Pro", 
      sub: "Living Your Dream",
      themeClass: "step-orange",
      iconSvg: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
          <line x1="4" y1="22" x2="4" y2="15" />
        </svg>
      )
    }
  ];

  return (
    <section className="roadmap-section-wrapper">
      <div className="roadmap-main-blue-box">
        
       
        <div className="roadmap-ambient-light" />

        
        <div className="roadmap-left-hero-block">
          <span className="roadmap-top-tag">YOUR CAREER PATH</span>
          <h2 className="roadmap-headline">
            Creator Career <br />
            <span className="roadmap-accent-text">Roadmap</span>
          </h2>
          <p className="roadmap-desc-paragraph">
            A step-by-step path designed to take you from a curious beginner to a monetized, full-time digital creator.
          </p>
        </div>

        
        <div className="roadmap-right-timeline-track">
          <div className="timeline-connecting-track" />

          {stepsData.map((step, index) => (
            <div className={`timeline-step-node ${step.themeClass}`} key={index}>
              <div className="timeline-bubble-circle">
                <span className="step-badge-num">{step.num}</span>
                <span className="step-icon-svg">{step.iconSvg}</span>
              </div>

              <div className="timeline-step-meta-info">
                <h4 className="step-main-title">{step.title}</h4>
                <p className="step-desc-subline">{step.sub}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}